import { inject } from '@angular/core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { CustomsIDService, PaginatedCustomsIDDTO } from '@api';
import { lastValueFrom } from 'rxjs';

interface CustomsIdState {
  paginatedCustomsId: PaginatedCustomsIDDTO | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: CustomsIdState = {
  paginatedCustomsId: null,
  isLoading: false,
  error: null,
};

export const CustomsIdStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),

  withMethods((store) => {
    const customsIdService = inject(CustomsIDService);

    return {
      async fetchCustomsId(page?: number, size?: number, sort?: string) {
        patchState(store, () => ({
          isLoading: true,
          error: null,
        }));
        try {
          const customsId = await lastValueFrom(customsIdService.getCustomsIDs(page, size, sort));
          patchState(store, () => ({
            paginatedCustomsId: customsId,
            isLoading: false,
          }));
        } catch (error) {
          console.error(`Error fetching customIds: ${error}`);
          patchState(store, () => ({
            isLoading: false,
          }));
        }
      },
    };
  }),
);
